import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "./pages/LandingPage";
import LegalMentions from "./pages/LegalMentions";
import CGU from "./pages/CGU";
import ScrollToTop from "./components/ScrollToTop";
import PartenairesPage from "./pages/PartenairesPage";
import PartenairesCategoryPage from "./pages/PartenairesCategoryPage";
import Navbar from "./components/layout/NavBar";
import Footer from "./components/layout/Footer";
import CookieConsent from "./components/CookieConsent";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import PolitiqueCookies from "./pages/PolitiqueCookies";
import AdoptableCatsPage from "./pages/AdoptableCatsPage";
import CatDetailPage from "./pages/AdoptableCatDetailPage"

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div>
          <ScrollToTop />
          <CookieConsent />
          <Navbar />

          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/mentions-legales" element={<LegalMentions />} />
            <Route path="/cgu" element={<CGU />} />
            <Route
              path="/politique-de-confidentialite"
              element={<PolitiqueConfidentialite />}
            />
            <Route
              path="/politique-cookies"
              element={<PolitiqueCookies />}
            />
            <Route path="/partenaires" element={<PartenairesPage />} />
            <Route
              path="/partenaires/:category"
              element={<PartenairesCategoryPage />}
            />
            <Route path="/adoption" element={<AdoptableCatsPage />} />
            <Route path="/adoption/:slug" element={<CatDetailPage />} />
          </Routes>

          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;